import { LineItem } from 'shared/types/cart';
import { Middleware, SWRHook, SWRResponse } from 'swr';
import { useChannel } from 'frontastic';

export const TEMP_ATTRIBUTE_FOR_BUNDLE = 'bundles';

export const useChannelLineitems = () => {
  const { channels } = useChannel();
  const channelsMiddleware: (myKey: string) => Middleware =
    (myKey: string) => (useSWRNext: SWRHook) => (key, fetcher, config) => {
      const swr: SWRResponse<any> = useSWRNext(key, fetcher, config);

      if (key === myKey && swr.data?.data?.lineItems && !swr.isLoading && !swr.isValidating && !swr.error) {
        const channeledItems = channelItems(swr.data?.data?.lineItems as LineItem[]);

        swr.data.data.channeledItems = channeledItems;
      }

      return swr;
    };

  const channelItems = (
    lineItems: LineItem[],
  ): {
    deliveryChannelItems: LineItem[];
    pickUpChannelsItems: {
      channelId: string;
      channelName: string;
      items: LineItem[];
    }[];
  } => {
    if (!lineItems?.length) {
      return {
        deliveryChannelItems: [],
        pickUpChannelsItems: [],
      };
    }
    const deliveryChannelItems = lineItems?.filter((item) => !item.supplyChannelId);
    const pickupItems = lineItems?.filter((item) => item.supplyChannelId);

    const pickUpChannelsItems = channels?.map((channel) => ({
      channelId: channel.channelId as string,
      channelName: channel.name as string,
      items: [] as LineItem[],
    }));
    pickupItems?.forEach((item) => {
      const channel = channels?.find((channel) => channel.channelId === item.supplyChannelId);
      const channelIndex = pickUpChannelsItems.findIndex((channel) => channel.channelId === item.supplyChannelId);
      if (channel) {
        pickUpChannelsItems[channelIndex]?.items.push(item);
      }
    });
    return {
      deliveryChannelItems,
      pickUpChannelsItems,
    };
  };

  return {
    channelsMiddleware,
  };
};
